import { useFlags } from "launchdarkly-react-client-sdk";
import { FLAGS, type FlagValues } from "./flags";

export type FeatureFlagsState = FlagValues & {
  hasEnterpriseAppEnabledFlag: boolean;
};

export function useFeatureFlags(): FeatureFlagsState {
  const flags = useFlags<Partial<FlagValues>>();

  return {
    ...FLAGS,
    ...flags,
    hasEnterpriseAppEnabledFlag: Object.hasOwn(flags, "enterpriseAppEnabled"),
  };
}
